// CSS Modules - component class name prefix: SubPage__

<template>
  <div class="SubPage__container">
    <PageHeader />
    <div class="SubPage__contentGrid SubPage__firstGrid">
      <Breadcrumbs :crumbs="crumbs" />
      <div class="SubPage__header columns is-mobile">
        <div class="column">
          <h1 class="SubPage__title">{{ title }}</h1>
        </div>
      </div>
    </div>
    <ResultList :config="searchConfig" />
    <Footer />
  </div>
</template>

<script>
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import Footer from "../Footer/Footer";
import PageHeader from "../PageHeader/PageHeader";
import ResultList from "../ResultList/ResultList";

export default {
  name: "SearchResultsPage",
  components: {
    Breadcrumbs,
    Footer,
    PageHeader,
    ResultList
  },
  props: {
    crumb: undefined,
    searchConfig: undefined,
    title: undefined
  }
};
</script>
